export default {
    loading: false,
    error: {},
    pages: [],
    page: {}
}